import React from "react";
import { Box, Typography } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  img: {},
});

const FeaturedProduct = ({ img, title, subtitle, linkTo, price }) => {
  const classes = useStyles();
  if (title === "Premium Heavy Duty Hand Wipes") {
    title = "Premium Heavy Duty Wipes";
  } else if (title === "Premium Skin Care & Anti-Bacterial Spray for Dogs") {
    title = "Anti-Bacterial Spray for Dogs";
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // border: "1px solid #f0f0f0",
        // boxShadow:
        //   "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
        marginBottom: "60px",
        marginLeft: "30px",
        paddingBottom: "140px",
        paddingTop: "30px",
        position: "relative",
        transition: "opacity 0.2s ease 0s",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          top: "+10px",
        }}
      >
        <HashLink to={"/product/" + linkTo + "#top"}>
          <img
            height="160"
            width="170"
            alt="abc"
            src={img}
            className="animation"
          />
        </HashLink>
      </Box>
      <Box
        sx={{
          textAlign: "center",
          width: 1,
          // backgroundColor: "#f5f5f5",
          position: "absolute",
          bottom: 0,
          pt: 1,
          pb: 0,
          fontWeight: 200,
          fontSize: "11px",
          height: "80px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <HashLink to={"/product/" + linkTo + "#top"}>
          <Typography
            sx={{ width: "80%", marginLeft: "auto", marginRight: "auto" }}
          >
            {title}
            <Box sx={{ pt: 1 }}>
              <span class="outer">
                <span class="inner">${price + 1}</span>
              </span>
              <span style={{ fontSize: "19px", color: "#508bed" }}>
                &nbsp;&nbsp;${price}
              </span>
            </Box>
          </Typography>
        </HashLink>
      </Box>
    </Box>
  );
};

export default FeaturedProduct;
